// 引入axios基本配置
import http from '@/api/fetch.js'

/**
 * 获取奖项列表
 */
export const queryAwardsList = (params) => {
    return http({
        url: 'console/api/v1/adverts/getAd',
        method: 'get',
        params: params
    })
}

/**
 * 获取共享卡片信息
 */
export const querySharedCardsInfo = (params) => {
    return http({
        url: 'laidanapp/api/v1/me/membercard/getById',
        method: 'get',
        params: params
    })
}

/**
 * 获取共享广告册信息
 */
export const querySharedBookInfo = (params) => {
    return http({
        url: 'laidanapp/api/v1/showcase/item/get',
        method: 'get',
        params: params
    })
}

/**
 * 获取验证码
 */
export const queryAuthCode = (params) => {
    return http({
        url: 'laidanapp/api/v1/verification_code/send',
        method: 'post',
        params: params
    })
}

/**
 * 验证码登录
 * @param params account 账号    verificationCode 验证码
 * @returns {*}
 */
export const authCodeLogin = (params) => {
    return http({
        url: 'laidanapp/api/v1/login/code',
        method: 'post',
        params: params
    })
}

/**
 * 查询抽奖商家信息
 * @param params  mid 商家ID
 * @returns {*}
 */
export const queryLotteryMerchant = (params) => {
    return http({
        url: 'laidanapp/api/v1/pm/shop/detail',
        method: 'post',
        params: params
    })
}

/**
 * 查询当前活动
 * @param params
 * @returns {*}
 */
export const queryNowActivity = () => {
    return http({
        url: 'laidanapp/api/v1/lotto/activity/now',
        method: 'post'
    })
}

/**
 * 创建平台抽奖码
 * @param params activityId 活动ID
 * @returns {*}
 */
export const createPlatformCode = (params) => {
    return http({
        url: 'laidanapp/api/v1/lucky/award/code/create',
        method: 'post',
        data: params
    })
}

/**
 * 查询商家抽奖结果
 * @param params code 抽奖码
 * @returns {*}
 */
export const merchantLotteryResult = (params) => {
    return http({
        url: 'laidanapp/api/v1/win/award/record/scan',
        method: 'post',
        params: params
    })
}

/**
 * 查询用户奖品列表
 * @param params  awardSource：101平台 102商家  page  size
 * @returns {*}
 */
export const queryUserPrize = (params) => {
    return http({
        url: 'laidanapp/api/v1/win/award/record/page',
        method: 'post',
        data: params
    })
}

/**
 * 查询用户抽奖码列表
 * @param params  activityId 活动ID  page  size
 * @returns {*}
 */
export const queryUserLottoCode = (params) => {
    return http({
        url: 'laidanapp/api/v1/lucky/award/code/page',
        method: 'post',
        data: params
    })
}

/**
 * 查询会员商家信息
 * @param params  merchantId 商家ID
 * @returns {*}
 */
export const queryMemberMerchant = (params) => {
    return http({
        url: 'laidanapp/api/v1/jyk/shop/detail',
        method: 'post',
        params: params
    })
}

/**
 * 加入商家会员
 * @param params
 * @returns {*}
 */
export const joinMerchantMember = (params) => {
    return http({
        url: 'laidanapp/api/v3/member/apply/join',
        method: 'post',
        data: params
    })
}

/**
 * 查询会员卡信息
 * @param params  id
 * @returns {*}
 */
export const queryMemberCardInfo = (params) => {
    return http({
        url: 'laidanapp/api/v3/me/membercard/detail',
        method: 'get',
        params: params
    })
}

/**
 * 查询广告纸
 * @param params distance 偏差米,latitude 维度, longitude 经度, page, size
 * @returns {*}
 */
export const queryMerchantAdPaper = (params) => {
    return http({
        url: 'laidanapp/api/v1/showcase/web/page',
        method: 'post',
        data: params
    })
}

/**
 * 获取pointsme菜单预览
 * @param params id 菜单ID
 * @returns {*}
 */
export const queryMenuPreview = (params) => {
    return http({
        url: 'pointsme/api/v3/menu/flyer/preview',
        method: 'post',
        data: params
    })
}

/**
 * 获取pointsme过敏源
 * @param params
 * @returns {*}
 */
export const queryAllergenList = (params) => {
    return http({
        url: 'pointsme/api/v3/menu/flyer/preview',
        method: 'post',
        data: params
    })
}

/**
 * 获取pointsme菜品详情
 * @param params
 * @returns {*}
 */
export const queryDishesDetail = (params) => {
    return http({
        url: 'pointsme/api/v3/menu/flyer/item/detail',
        method: 'post',
        data: params
    })
}
